import * as React from 'react';
import { PK } from 'common/types';
import { useParams } from 'react-router-dom';

import { DetailsCard, DetailsSuspense } from 'templates/details';
import { useBlogDetails } from '../queries';
import BlogCoreWithGet from '../components/BlogCoreWithGet';
import { Blog } from '../../../base/api/types';
import { BlogFields, fields } from '../consts';
import { STATUSES_OPTIONS } from '../../../common/consts';

const transformBlog = (raw: Blog): BlogFields => ({
  [fields.title.name]: raw.title,
  [fields.description.name]: raw.description,
  [fields.url.name]: raw.url,
  [fields.image_url.name]: raw.image_url,
  [fields.status.name]: STATUSES_OPTIONS.filter(({ value }) => value === raw.status),
  [fields.is_featured.name]: raw.is_featured,
  [fields.is_inspiration.name]: raw.is_inspiration,
});

const BlogsDetails = () => {
  const { pk } = useParams<{ pk?: PK }>();
  const { data: blog, ...query } = useBlogDetails(pk);
  const defaultValues = blog && transformBlog(blog);

  return (
    <DetailsCard created={blog?.published_at} lastUpdate={blog?.modified_at}>
      <DetailsSuspense isLoading={query.isLoading} error={query.error}>
        <BlogCoreWithGet layout="overview" defaultValues={defaultValues} pk={blog?.pk} />
      </DetailsSuspense>
    </DetailsCard>
  );
};

export default BlogsDetails;
